module.exports = __webpack_public_path__ + "static/media/tomaz_kramberger_cut.1c875150.jpg";